import {
  createContext,
  createElement,
  useContext,
  type ReactElement,
  type ReactNode
} from 'react';
import type { Deal } from '~/models/Deal';

const DealContext = createContext<Deal | null>(null);

type ProviderProps = {
  deal: Deal;
  children: ReactNode;
};

export const DealContextProvider = ({
  deal,
  children
}: ProviderProps): ReactElement =>
  createElement(DealContext.Provider, { value: deal }, children);

export const useDealContext = (): Deal =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  useContext(DealContext)!;
